import request from "@/common/js/request.js";

// startTest 开始答题
export function startTest(obj) {
  return request({
    url: "/examination/startTest",
    method: "get",
    params: obj
  });
}

// 减少考试次数
export function changeTimes(obj) {
  return request({
    url: "examination/change/times",
    method: "put",
    params: obj
  });
}

// submitTest 提交检测或练习
export function submitTest(obj) {
  return request({
    url: "/examination/submitTest",
    method: "post",
    data: obj
  });
}
// 查询用户最近一次测验/练习详情
export function selectLastExamination(obj) {
  return request({
    url: "/examination/selectLastExamination",
    method: "get",
    params: obj
  });
}

// startTest 继续测验/练习
export function continueTest(obj) {
  return request({
    url: "/examination/continueTest",
    method: "get",
    params: obj
  });
}

// saveTest 保存测验/练习
export function saveTest(obj) {
  return request({
    url: "/examination/saveTest",
    method: "post",
    data: obj
  });
}

// startTest 重新开始测验/练习
export function restartTest(obj) {
  return request({
    url: "/examination/restartTest",
    method: "get",
    params: obj
  });
}

// selectResolve 查看测验/练习试题解析
export function selectResolve(obj) {
  return request({
    url: "/examination/selectExaminationResolve",
    method: "get",
    params: obj
  });
}

// OwnExaminationInfos 获取用户测验/练习结果信息
export function OwnExaminationInfos(obj) {
  return request({
    url: "/examination/selectOwnExaminationInfos",
    method: "get",
    params: obj
  });
}

// selectOwnErrorExamination 查询用户错题
export function OwnErrorExamination(obj) {
  return request({
    url: "/examination/selectOwnErrorExamination",
    method: "get",
    params: obj
  });
}

// selectCountErrorNumbs 查询用户总错题数
export function CountErrorNumbs(obj) {
  return request({
    url: "/examination/selectCountErrorNumbs",
    method: "get",
    params: obj
  });
}

// selectUserExaminationManager 获取用户题库
export function UserExaminationManager(obj) {
  return request({
    url: "/examination/selectUserExaminationManager",
    method: "get",
    params: obj
  });
}

// electCountExamNumbs 获取用户题库试题总数
export function CountExamNumbs(obj) {
  return request({
    url: "/examination/selectCountExamNumbs",
    method: "get",
    params: obj
  });
}
// selectErrorExamInfo 查询错题详情
export function selectErrorExamInfo(obj) {
  return request({
    url: "/examination/selectErrorExamInfo",
    method: "get",
    params: obj
  });
}
// selectErrorExamInfo 错题重做
export function submitErrorExams(id, obj) {
  return request({
    url: "/examination/submitErrorExams?" + "userExaminationId=" + id,
    method: "post",
    data: obj
  });
}

// 文件上传接口 POST /file/uploadFileByType
export function uploadFile(type, obj) {
  return request({
    // url: 'file/uploadFileByType?' + 'fileType=' + type,
    url: "aliyun/oss/putObject",
    method: "post",
    data: obj
  });
}



// WEBPACK FOOTER //
// ./src/api/examination.js